import { useSelector } from 'react-redux';
import type { StateWithPsaps } from './psapInfoSlice';

const selectCurrentPSAP = (state: StateWithPsaps) => state.psaps.currentPSAP;
export function useCurrentPSAP() {
  const currentPSAP = useSelector(selectCurrentPSAP);

  if (!currentPSAP) {
    throw new Error('No current PSAP available.');
  }
  return currentPSAP;
}

export function useCurrentPSAPAccountID() {
  return useSelector(
    (state: StateWithPsaps) => state.psaps.currentPSAP.account_id,
  );
}
